import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_TRADEMARKED_LOGO } from '../../config/assets';
import { useI18n } from '../../lib/hook/useI18n';

const PoweredBy: React.FC = (): JSX.Element => {
  const { t } = useI18n();

  return (
    <Box
      alignItems="center"
      component="a"
      display="flex"
      href="https://www.enableus.com/who-is-enable-us"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Typography
        style={{ color: 'var(--powered-by-text-color)', marginRight: '4px' }}
        variant="subtitle2"
      >
        {t('powered_by')}{' '}
      </Typography>
      &nbsp;
      <img
        alt="Mindtickle trademarked logo"
        height="22px"
        src={APP_TRADEMARKED_LOGO}
      />
    </Box>
  );
};

export default PoweredBy;
